module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ISO 140012015.e43025ad.png";